let apiBaseUrl = "https://backendrodeo.glohtesting.com/api/v1/";
let socketUrl = "https://backendrodeo.glohtesting.com:6682";

const appStage = process.env.REACT_APP_STAGE;

if (appStage == "dev") {
  apiBaseUrl = "https://irbackend.dreamztesting.com/api/v1/";
  socketUrl = "https://socket.insiderodeo.com:6670/";
}  else if (appStage === "stage") {
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v1/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
}  else if (appStage == "uat") {
  apiBaseUrl = "https://backendrodeo.glohtesting.com/api/v1/";
  socketUrl = "https://backendrodeo.glohtesting.com:6682";
} else if (appStage == "prod") {
  apiBaseUrl = "https://api.insiderodeo.com/api/v1/";
  socketUrl = "https://ws.insiderodeo.com/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
